function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "12. Crossover car");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "_12._Crossover_car",
  "data-name": "12. Crossover car"
}, /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M48,25.76a7.28,7.28,0,0,0-3.5-4.63c-1.47-.83-1.9-.77-9-2.06C29.91,13.5,29.1,12,26.34,12H8.74a4,4,0,0,0-3.47,2c-2.88,5-3.08,5.37-3.17,5.55S2,19.53,2,26H1a1,1,0,0,0-1,1v4a1,1,0,0,0,1,1H7.1a5,5,0,0,0,9.8,0H31.1a5,5,0,0,0,9.8,0,40.28,40.28,0,0,0,4.59-.74,3,3,0,0,0,2.51-3A17.1,17.1,0,0,0,48,25.76ZM43.72,23a5,5,0,0,1,1.81,2H44A1,1,0,0,1,43.72,23ZM32.59,19H24.87l-.72-5C28.31,14,27,13.44,32.59,19ZM13.5,19c-2.57-3.43-2.53-2.67-1-5h3.32l-.72,5Zm4.37-5h4.26l.72,5h-5.7ZM5,21a1,1,0,0,1,0,2H4V21Zm7,13a3,3,0,1,1,3-3A3,3,0,0,1,12,34Zm24,0a3,3,0,1,1,3-3A3,3,0,0,1,36,34Zm9.16-4.71C40.83,30,41,30,40.9,30a5,5,0,0,0-9.8,0H16.9a5,5,0,0,0-9.8,0H2V28H3a1,1,0,0,0,1-1V25H5c3.93,0,4.15-6-.28-6,3-5.27,2.32-5,5.41-5a3,3,0,0,0-.08,3.73L12.2,20.6c.43.58-1.17.4,22.71.4l6.69,1.22A3,3,0,0,0,44,27h2v1.31A1,1,0,0,1,45.16,29.29Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M36.92,30.62a1,1,0,1,0-1.75.94A1,1,0,0,0,36.92,30.62Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M12.38,30.08A1,1,0,1,0,13,31,1,1,0,0,0,12.38,30.08Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M28,23H26a1,1,0,0,0,0,2h2A1,1,0,0,0,28,23Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M20,23H18a1,1,0,0,0,0,2h2A1,1,0,0,0,20,23Z"
}));

var SvgCrossoverCar = function SvgCrossoverCar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCrossoverCar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/CrossoverCar.fa015d50.svg";
export { ForwardRef as ReactComponent };